export default __webpack_public_path__ + "static/media/ny-icone-2x.90ab72b3.png";